export const DEVICE_TOKEN = 'goodoc_device_token';
export const ACCESS_TOKEN = 'goodoc_user_token';
export const REFRESH_TOKEN = 'goodoc_refresh_token';
export const REFRESH_TOKEN_EXPIRED_AT = 'goodoc_refresh_token_expired_at';
